import {Redemption} from "types/Redemption";
import {dateTime} from "services/date";

export default function deserializeRedemption(redemption: any): Redemption {
    redemption.made_at = dateTime(redemption.made_at)

    return redemption
}